import { camelizeKeys } from 'humps'
import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components'

import { fetchAnything, openError, startLoading, stopLoading } from 'containers/App/reducers'
import loginStorage, { CHECKIN_USER_DATA, GENERAL_CHECKIN } from 'utils/loginStorage'
import theme from 'vars/theme'

import { requestGet } from '../api'
import Header from '../components/Header'
import OutlineButton from '../components/OutlineButton'
import { SpFrame } from '../components/SpFrame'
import { HEADER_HEIGHT } from '../constants'
import { updateDriver } from '../reducers'
import SessionStorage from '../SessionStorage'
import Storage from '../Storage'
import { isSp } from '../utils'

const isLogin = (url, loginTenants, isGeneral) => {
  if (isGeneral) {
    return loginTenants[url]
  }

  const nodes = url.split('/')
  const tenantId = nodes[nodes.length - 1]
  return loginTenants[tenantId]
}

const HeadingOutline = styled.h2`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #333;
  text-align: center;
`

const HeadingOutlineSp = styled.h2`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #333;
  text-align: center;
`

const getButtonWidth = (btnNum) => {
  if (btnNum <= 4) return '400px'

  const columns = Math.ceil(btnNum / 4)
  return `calc(100% / ${columns < 5 ? columns : 5} - var(--margin-element) * 2)`
}

const OutlineButtonCustom = styled(OutlineButton)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  font-weight: bold;
  font-size: 24px;
  height: 72px;
  --margin-element: 10px;
  margin: 0 var(--margin-element);
  width: ${({ btnNum }) => getButtonWidth(btnNum)};

  ${({ isLogin }) =>
    isLogin &&
    css`
      color: white;
      background-color: #247cdb;
    `}

  @media only screen and (max-width: 1280px) {
    width: ${({ btnNum }) =>
      btnNum && btnNum < 3
        ? `calc(100% / ${btnNum} - var(--margin-element) * 2)`
        : 'calc(100% / 3 - var(--margin-element) * 2)'}

  @media only screen and (max-width: 820px) {
    width: calc(100% / 2 - var(--margin-element) * 2);
  }

  @media only screen and (max-width: 500px) {
    width: calc(100% - var(--margin-element) * 2);
  }
`

const ContainerListButton = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 auto;
  flex-direction: column;
  max-height: 360px;
`

class MultiTenantsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSp: isSp(),
    }
    const sessions = loginStorage.getCheckinAuthData(CHECKIN_USER_DATA) || []
    this.loginTenants = sessions.reduce(
      (ac, item) => ({
        ...ac,
        [item.uid]: true,
      }),
      {}
    )
    const sessionGeneral = loginStorage.getCheckinAuthData(GENERAL_CHECKIN) || []
    this.loginGeneralTenants = sessionGeneral.reduce(
      (ac, item) => ({
        ...ac,
        [item.generalReceptionNumber]: true,
      }),
      {}
    )
  }

  async componentDidMount() {
    const { match } = this.props
    const {
      params: { multiTenantId },
    } = match

    let resp

    this.props.startLoading()

    try {
      resp = await requestGet('/tablets/load_multi_tenants', { mid: multiTenantId }, false)
    } catch (error) {
      this.props.openError(error.message)
      return
    } finally {
      this.props.stopLoading()
    }

    const multiTenants = camelizeKeys(resp).multiTenants
    const sortedMultiTenants = _.sortBy(multiTenants, (tenant) => tenant.id)
    this.props.updateDriver({ multiTenantId, multiTenants: sortedMultiTenants })
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({ isSp: isSp() })
  }

  onClickNormalTenant = (url = '') => {
    const { match } = this.props
    const {
      params: { multiTenantId },
    } = match

    const nodes = url.split('/')
    const tenantId = nodes[nodes.length - 1]
    Storage.write('tenantId', tenantId)
    SessionStorage.write('multiTenantId', multiTenantId)

    this.props.history.push(`/receipt-booking/${url}`, { multiTenantId })
  }

  onClickGeneralTenant = (url = '') => {
    const { match } = this.props
    const {
      params: { multiTenantId },
    } = match

    SessionStorage.write('multiTenantId', multiTenantId)

    this.props.history.push(`/general-reception-desk/${url}`, { multiTenantId })
  }

  render() {
    const { multiTenants } = this.props
    const normalMultiTenant = multiTenants?.filter((tenant) => !tenant.generalReceptionFlag)
    const generalMultiTenant = multiTenants?.filter((tenant) => tenant.generalReceptionFlag)

    if (this.state.isSp) {
      return (
        <div style={{ backgroundColor: theme.graySoft6, height: '100vh', fontSize: 18 }}>
          <Header isSp />
          <div
            className="p-4"
            style={{
              height: window.innerHeight - HEADER_HEIGHT,
              overflowY: 'auto',
            }}
          >
            <SpFrame dataDgId="sp-multi-tenants-destination-title" title="行き先を選択してください">
              <div className="mx-auto mt-3 d-flex flex-column align-items-center">
                {normalMultiTenant.length > 0 && (
                  <>
                    {generalMultiTenant?.length > 0 && (
                      <HeadingOutlineSp>通常受付</HeadingOutlineSp>
                    )}
                    {normalMultiTenant.map((tenant) => (
                      <OutlineButton
                        key={tenant.id}
                        className="text-center mb-3 px-4 font-weight-bold"
                        style={{
                          fontSize: 16,
                          width: '100%',
                          height: 56,
                          ...(isLogin(tenant.url, this.loginTenants)
                            ? { color: 'white', backgroundColor: theme.blueMedium5 }
                            : { color: theme.grayDark }),
                        }}
                        onClick={() => this.onClickNormalTenant(tenant.url)}
                      >
                        {tenant.name}
                      </OutlineButton>
                    ))}
                  </>
                )}
              </div>

              {normalMultiTenant.length > 0 && generalMultiTenant.length > 0 ? (
                <hr style={{ width: '100%', margin: '20px 0', borderWidth: 2 }} />
              ) : (
                <div />
              )}

              <div
                className="mx-auto mt-3 d-flex flex-column align-items-center"
                style={{ paddingBottom: 60 }}
              >
                {generalMultiTenant.length > 0 && (
                  <>
                    <HeadingOutlineSp>総合受付</HeadingOutlineSp>
                    {generalMultiTenant.map((tenant) => (
                      <OutlineButton
                        key={tenant.id}
                        className="text-center mb-3 px-4 font-weight-bold"
                        style={{
                          fontSize: 16,
                          width: '100%',
                          height: 56,
                          ...(isLogin(tenant.url, this.loginTenants)
                            ? { color: 'white', backgroundColor: theme.blueMedium5 }
                            : { color: theme.grayDark }),
                        }}
                        onClick={() => this.onClickGeneralTenant(tenant.url)}
                      >
                        {tenant.name}
                      </OutlineButton>
                    ))}
                  </>
                )}
              </div>
            </SpFrame>
          </div>
        </div>
      )
    }

    return (
      <div style={{ backgroundColor: '#EDEDED', height: '100vh', fontSize: 18 }}>
        <Header />

        <div
          className="m-3 p-4 bg-white overflow-auto"
          style={{ borderRadius: 12, height: 'calc(100vh - 92px)' }}
        >
          <div
            data-dg-id="multi-tenants-destination-title"
            className="text-center mb-4 font-weight-bold"
            style={{ fontSize: 32 }}
          >
            行き先を選択してください
          </div>
          <div className="mx-auto">
            {normalMultiTenant.length > 0 && (
              <>
                {/* 「通常受付」であるかどうかは総合受付も存在する時のみ表示する */}
                {generalMultiTenant?.length > 0 && <HeadingOutline>通常受付</HeadingOutline>}
                <ContainerListButton
                  style={{ width: normalMultiTenant.length < 9 ? 840 : 'auto', height: 360 }}
                >
                  {normalMultiTenant.map((tenant) => (
                    <OutlineButtonCustom
                      btnNum={normalMultiTenant.length}
                      key={tenant.id}
                      color="primary"
                      className="mb-3 px-4"
                      isLogin={isLogin(tenant.url, this.loginTenants, false)}
                      onClick={() => this.onClickNormalTenant(tenant.url)}
                    >
                      {tenant.name}
                    </OutlineButtonCustom>
                  ))}
                </ContainerListButton>
              </>
            )}

            {generalMultiTenant.length > 0 && (
              <>
                <hr style={{ width: '100%', margin: '20px 0', borderWidth: 2 }} />
                <HeadingOutline>総合受付</HeadingOutline>
                <ContainerListButton
                  style={{ width: generalMultiTenant.length < 9 ? 840 : 'auto', height: 360 }}
                >
                  {generalMultiTenant.map((tenant) => (
                    <OutlineButtonCustom
                      btnNum={generalMultiTenant.length}
                      key={tenant.id}
                      color="primary"
                      className="mb-3 px-4"
                      isLogin={isLogin(tenant.url, this.loginGeneralTenants, true)}
                      onClick={() => this.onClickGeneralTenant(tenant.url)}
                    >
                      {tenant.name}
                    </OutlineButtonCustom>
                  ))}
                </ContainerListButton>
              </>
            )}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const reception = state.get('reception')
  return {
    multiTenants: reception.driver.multiTenants,
  }
}

const mapDispatchToProps = {
  fetchAnything,
  updateDriver,
  openError,
  startLoading,
  stopLoading,
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiTenantsPage)
